import clsxm from "@/lib/clsxm";
import type {FC} from "react";

const ScopeAvatar: FC<{className?: string; name: string; picture: string | null}> = ({className, name, picture}) =>
  picture ? (
    <img alt="" className={clsxm("size-6 shrink-0 rounded-md object-cover", className)} src={picture} />
  ) : (
    <span
      className={clsxm(
        "bg-primary-medium-solid text-3xs flex size-6 shrink-0 items-center justify-center rounded-md font-semibold text-white",
        className,
      )}>
      {name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0])
        .join("")
        .toUpperCase()}
    </span>
  );

export default ScopeAvatar;
